export default "__VITE_ASSET__CxKhQUyL__"